import React from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection = () => {
  return <section className="w-full bg-gradient-to-br from-white via-teal-50 to-gray-50 py-16 px-4 overflow-hidden relative" data-id="element-378">
      {/* Background pattern elements for visual interest */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-379">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-teal-300 filter blur-3xl" data-id="element-380"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 rounded-full bg-blue-300 filter blur-3xl" data-id="element-381"></div>
      </div>
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-382">
        <div className="text-center mb-6" data-id="element-383">
          <span className="bg-yellow-100 text-yellow-800 text-sm font-medium px-4 py-1.5 rounded-full inline-block shadow-sm border border-yellow-200 animate-pulse" data-id="element-384">
            <span className="mr-2" data-id="element-385">🔥</span> This Week Only: Introductory batch
            pricing is active. Ships Friday.
          </span>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-8 mb-12" data-id="element-386">
          <div className="md:w-1/2 text-left" data-id="element-387">
            <h1 className="text-4xl md:text-5xl font-bold text-teal-600 mb-4 leading-tight" data-id="element-388">
              Ardava® Bamboo Compression Sleeve
              <span className="block text-2xl md:text-3xl mt-2 text-teal-700" data-id="element-389">
                The Knee Sleeve That{' '}
                <span className="underline decoration-teal-400 decoration-4" data-id="element-390">
                  Actually Stays Up
                </span>
              </span>
            </h1>
            <p className="text-gray-600 text-lg mb-6" data-id="element-391">
              Experience all-day comfort with the bamboo-blend sleeve designed
              to feel like a second skin—and stay put without constant
              adjustments
            </p>
            <div className="flex items-center mb-6 bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-392">
              <div className="flex text-yellow-400 items-center" data-id="element-393">
                <span className="text-xl" data-id="element-394">★★★★★</span>
                <span className="ml-2 text-gray-700 font-medium" data-id="element-395">
                  <span className="font-bold" data-id="element-396">4.9/5</span> from 2,000+ verified
                  buyers
                </span>
              </div>
            </div>
            <a href="https://silentstruggle.shop/ardava-checkout" className="to-checkout" data-pass-params="1" style={{
            display: 'block'
          }} data-id="element-397">
              <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3.5 rounded-lg font-medium w-full transition-colors text-lg shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-398">
                Find Your Size & Get a Pair — Ships Friday
              </button>
            </a>
            <div className="flex flex-wrap items-center justify-between mt-4 text-sm text-gray-600" data-id="element-399">
              <div className="flex items-center" data-id="element-400">
                <svg className="w-5 h-5 text-teal-500 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-401">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-402" />
                </svg>
                60-Day Guarantee
              </div>
              <div className="flex items-center" data-id="element-403">
                <svg className="w-5 h-5 text-teal-500 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-404">
                  <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" data-id="element-405"></path>
                  <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2v5a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H19a1 1 0 001-1V9a1 1 0 00-.293-.707L16.414 5H13V4a1 1 0 00-1-1H3z" data-id="element-406"></path>
                </svg>
                Free Shipping on Pairs
              </div>
              <div className="flex items-center" data-id="element-407">
                <svg className="w-5 h-5 text-teal-500 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" data-id="element-408">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-409" />
                </svg>
                Ships Friday
              </div>
            </div>
            {/* TrustLock Badge */}
            <div className="mt-4 flex justify-center" data-id="element-410">
              <a name="trustbadge" href="https://trustlock.co" data-id="element-411">
                <img name="trustseal" alt="Trust Badges" style={{
                border: 0
              }} src="https://trustlock.co/wp-content/uploads/2019/01/credit-card-logos-free-png-image-trans.png" width="294" height="60" data-id="element-412" />
              </a>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-413">
            <div className="relative" data-id="element-414">
              <div className="absolute -top-4 -left-4 w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center text-yellow-800 font-bold text-sm z-10 shadow-md border border-yellow-200 rotate-12" data-id="element-415">
                <div className="text-center leading-tight" data-id="element-416">
                  <div data-id="element-417">60-DAY</div>
                  <div data-id="element-418">GUARANTEE</div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 relative z-0" data-id="element-419">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kpRJyNtv3aTsb5mqANf3ms/small-Square-KneeSleeve.webp" alt="Ardava Bamboo Compression Sleeve" className="w-full max-w-md mx-auto" data-id="element-420" />
                <div className="absolute bottom-4 right-4 bg-white rounded-lg shadow-md p-3 border border-gray-100 max-w-[200px]" data-id="element-421">
                  <div className="flex items-start" data-id="element-422">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3JVtjEPcH78ohjixHmv79p/395282767_333088312736901_187241778219682257_n.jpg" alt="Customer" className="w-10 h-10 rounded-full object-cover border-2 border-teal-100" data-id="element-423" />
                    <div className="ml-2" data-id="element-424">
                      <div className="text-yellow-400 text-sm" data-id="element-425">★★★★★</div>
                      <p className="text-xs text-gray-700 italic" data-id="element-426">
                        "I did a 3-mile walk and never touched it!"
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-427">
                        — Beth K., Verified Buyer
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-428">
                <div className="grid grid-cols-2 gap-3" data-id="element-429">
                  <div className="flex items-start" data-id="element-430">
                    <svg className="w-5 h-5 text-teal-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-431">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-432" />
                    </svg>
                    <p className="text-sm text-gray-700" data-id="element-433">
                      <strong className="text-teal-700" data-id="element-434">Breathable</strong>{' '}
                      bamboo-blend
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-435">
                    <svg className="w-5 h-5 text-teal-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-436">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-437" />
                    </svg>
                    <p className="text-sm text-gray-700" data-id="element-438">
                      <strong className="text-teal-700" data-id="element-439">Stay-put</strong> design
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-440">
                    <svg className="w-5 h-5 text-teal-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-441">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-442" />
                    </svg>
                    <p className="text-sm text-gray-700" data-id="element-443">
                      <strong className="text-teal-700" data-id="element-444">
                        360° compression
                      </strong>
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-445">
                    <svg className="w-5 h-5 text-teal-500 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-446">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-447" />
                    </svg>
                    <p className="text-sm text-gray-700" data-id="element-448">
                      <strong className="text-teal-700" data-id="element-449">Wash durable</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100 mb-8" data-id="element-450">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-451">
            <div className="flex items-center" data-id="element-452">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4MCo2g1R6nYykgBbAUGNUF/walkingSpecialist-2.webp" alt="Movement Specialist" className="w-16 h-16 rounded-full object-cover border-2 border-teal-100 mr-4" data-id="element-453" />
              <div data-id="element-454">
                <h3 className="font-semibold text-teal-700" data-id="element-455">
                  Independent Specialist Review
                </h3>
                <p className="text-sm text-gray-600 italic" data-id="element-456">
                  "Comfortable all-day use and fewer mid-day
                  readjustments—especially on stairs and longer walks."
                </p>
              </div>
            </div>
            <div className="flex flex-wrap justify-center gap-3" data-id="element-457">
              <div className="bg-gray-50 px-3 py-1.5 rounded-full text-xs font-medium text-gray-700" data-id="element-458">
                Stairs
              </div>
              <div className="bg-gray-50 px-3 py-1.5 rounded-full text-xs font-medium text-gray-700" data-id="element-459">
                Long Walks
              </div>
              <div className="bg-gray-50 px-3 py-1.5 rounded-full text-xs font-medium text-gray-700" data-id="element-460">
                12-Hour Shifts
              </div>
              <div className="bg-gray-50 px-3 py-1.5 rounded-full text-xs font-medium text-gray-700" data-id="element-461">
                Daily Wear
              </div>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-462">
          <p className="text-gray-700 text-lg mb-6 max-w-3xl mx-auto" data-id="element-463">
            Tired of sleeves that won't stay up? Most people quit neoprene
            because it gets hot, skin gets slick, and cuffs start to roll.
            Ardava fixes it at the fabric + fit level—so comfort and "stay-put"
            work together.
          </p>
          <CTAButton data-id="element-464" />
        </div>
      </div>
    </section>;
};